module.exports = __webpack_public_path__ + "static/media/0013-Erkundigen_mV_ID_2.aebf06bf.mp3";